<div *ngIf="service.show">
    <ul nz-menu nzMode="horizontal">
        <li nz-menu-item *ngFor="let dashboard of service.ungrouped" [nzSelected]="activeLink.isActive">
            <a [routerLink]="dashboard.route" [queryParams]="linkQueryParams()" routerLinkActive #activeLink="routerLinkActive">{{ dashboard.name }}</a>
        </li>

        <li
            nz-submenu
            *ngFor="let group of service.grouped"
            [nzTitle]="group.selectedTitle || group.groupName"
            nzIcon="caret-down"
        >
            <ul>
                <li nz-menu-item *ngFor="let dashboard of group.items" [nzSelected]="activeLink.isActive">
                    <a [routerLink]="dashboard.route" [queryParams]="linkQueryParams()" routerLinkActive #activeLink="routerLinkActive">{{ dashboard.name }}</a>
                </li>
            </ul>
        </li>
    </ul>
</div>
